export const BASE_PATH = "https://web-personal-rafael-acosta.herokuapp.com/api";
// export const BASE_PATH = "http://localhost:3977/api";
export const API_VERSION = "v1";
export const ACCESS_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";